import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Settings } from 'lucide-react';
import { useLang } from '../i18n';

export default function CookiePolicy() {
  const { t } = useLang();
  const openPrefs = () => window.__yupOpenCookiePrefs && window.__yupOpenCookiePrefs();
  return (
    <div className="max-w-3xl mx-auto px-6 py-16 md:py-20 text-white/85" data-testid="cookie-policy-page">
      <Link to="/" className="inline-flex items-center gap-2 text-[color:var(--yup-primary)] mb-8 hover:underline text-sm">
        <ArrowLeft size={16} /> {t('backHome')}
      </Link>
      <h1 className="text-3xl md:text-4xl font-bold text-[color:var(--yup-primary)] mb-2">Cookie Policy</h1>
      <p className="text-white/60 text-sm mb-10">Ultimo aggiornamento: 19 Febbraio 2026</p>

      <div className="space-y-8 leading-relaxed">
        <section>
          <h2 className="text-xl font-semibold text-white mb-2">Cosa sono i cookie</h2>
          <p>I cookie sono piccoli file di testo salvati sul tuo dispositivo dai siti che visiti. Ci permettono di far funzionare correttamente il sito, ricordare le tue preferenze e — se accetti — misurarne l'utilizzo in forma aggregata.</p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-white mb-2">Categorie di cookie utilizzate</h2>

          <div className="rounded-lg border border-white/10 bg-white/[0.03] p-5 mb-4">
            <div className="flex items-center justify-between">
              <h3 className="text-white font-semibold">Cookie tecnici (necessari)</h3>
              <span className="text-[10px] uppercase tracking-widest text-[color:var(--yup-primary)]">Sempre attivi</span>
            </div>
            <p className="text-white/75 text-sm mt-2">Essenziali per il funzionamento del sito (es. gestione della sessione admin JWT, preferenza lingua, consenso cookie). Non richiedono il tuo consenso.</p>
          </div>

          <div className="rounded-lg border border-white/10 bg-white/[0.03] p-5 mb-4">
            <h3 className="text-white font-semibold">Cookie analitici</h3>
            <p className="text-white/75 text-sm mt-2">Ci aiutano a capire come i visitatori interagiscono con il sito, raccogliendo dati aggregati e anonimi. Attivi solo con il tuo consenso.</p>
          </div>

          <div className="rounded-lg border border-white/10 bg-white/[0.03] p-5">
            <h3 className="text-white font-semibold">Cookie di marketing</h3>
            <p className="text-white/75 text-sm mt-2">Utilizzati per mostrare contenuti e promozioni personalizzate. Attivi solo con il tuo consenso.</p>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-white mb-2">Gestione preferenze</h2>
          <p>Puoi modificare in qualsiasi momento le tue scelte:</p>
          <button
            onClick={openPrefs}
            className="mt-4 inline-flex items-center gap-2 px-5 py-2.5 rounded-lg font-semibold text-black"
            style={{ background: 'linear-gradient(135deg, var(--yup-primary), #d4c599)' }}
            data-testid="cookie-open-prefs-btn"
          >
            <Settings size={16} /> Apri preferenze cookie
          </button>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-white mb-2">Servizi di terze parti</h2>
          <p>Il sito integra servizi esterni che possono impostare i propri cookie o raccogliere dati tecnici:</p>
          <ul className="list-disc list-inside mt-3 space-y-1 text-white/75">
            <li><strong>OpenStreetMap / Leaflet</strong> — mappe interattive.</li>
            <li><strong>Open-Meteo</strong> — dati meteorologici.</li>
            <li><strong>Nominatim OSM</strong> — geocoding degli indirizzi.</li>
            <li><strong>Wix static CDN</strong> — hosting immagini importate.</li>
            <li><strong>OpenAI</strong> — chatbot AI multilingua.</li>
          </ul>
          <p className="mt-3 text-white/70 text-sm">Per maggiori dettagli sul trattamento dati vedi la <Link to="/privacy-policy" className="text-[color:var(--yup-primary)] underline">Privacy Policy</Link>.</p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-white mb-2">Come disabilitare i cookie dal browser</h2>
          <p>Oltre alle preferenze qui sopra, puoi impostare il tuo browser per rifiutare i cookie: Chrome, Firefox, Safari, Edge — cerca "Cookie" nelle impostazioni Privacy.</p>
        </section>
      </div>
    </div>
  );
}
